/* unplugin-vue-components disabled */import { render } from "./BlockRotateRender.vue?vue&type=template&id=13f3444e&scoped=true"
import script from "./BlockRotateRender.vue?vue&type=script&lang=js"
export * from "./BlockRotateRender.vue?vue&type=script&lang=js"

import "./BlockRotateRender.vue?vue&type=style&index=0&id=13f3444e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f3444e"]])

export default __exports__